import React from "react";

const Table = ({ technicalData, types }) => {

    const getEngineJSX = (v, i) => {
        if (typeof v === "string") return (<td key={i}>{v}</td>);

        return (
            <td key={i}>
                {
                    v.map((engine, index) => {
                        if (index === 0) return (<span key={index}>{engine}</span>);
                        if (engine.indexOf("/") === 0) {return (<div key={index}>{engine}</div>)};
                        if (index % 2 === 0 && v[index - 1].indexOf("/") !== 0) return (<div key={index}><i> lub </i>{engine}</div>);
                        return (<span key={index}><i> lub </i>{engine}</span>);
                    })
                }
            </td>
        );
    }

    if (technicalData == null || technicalData.versions.length <= 0) return (<></>);
    return (
        <div>
            <div className="table_container">
                <table>
                    <thead><tr><td colSpan={technicalData.versions.length + 1}>Dane techniczne</td></tr></thead>
                    <tbody>
                        {
                            types.map((type, i) => (
                                <tr key={i}>
                                    <td className="label">{type}</td>
                                    {
                                        technicalData[Object.keys(technicalData)[i]].map((v, index) => {
                                            if (Object.keys(technicalData)[i] === "engines") {return getEngineJSX(v, index)}
                                            return (<td key={index}>{v}</td>);
                                        })
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div className="remarks">
                <div className="remark">* Dane z {technicalData.produced_as_of}</div>
                {
                    technicalData.remarks.map((remark, i) => (
                        <div key={i} className="remark">{remark}</div>
                    ))
                }
            </div>
        </div>
    );
};

export default Table;